"use client"
import { useCallback, useState } from "react";

export type TogglerProps = {
    isOpen: boolean;
    toggle: () => void;
}

export function Toggler(): TogglerProps {
    const [isOpen, setOpen] = useState<boolean>(false);

    const toggle = useCallback(() => {
        setOpen((state) => !state)
    }, [setOpen])

    return { isOpen, toggle}
}